import { ConfirmationDialog } from './confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeddataThemeModule } from '@meddatacore/ui';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ConfirmationDialog],
  imports: [CommonModule, MatDialogModule, MeddataThemeModule, MatCardModule, MatIconModule, MatButtonModule],
  exports: [ConfirmationDialog],
})
export class ConfirmationDialogModule { }
